import { API, API_GET_ID } from "../../../Config";

export const GetSingleService = (id) => {
  return API_GET_ID(API.SingleService, id);
};
